'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _placeholder = require('./placeholder');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_placeholder).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/view/placeholder/index.js
// module id = 222
// module chunks = 0